export default __webpack_public_path__ + "static/modal-bg-2a42734991fbfd13e7608ad46f7c504b.png";